import { createContext, PropsWithChildren } from "react";

export const BidItemContext = createContext({
  toggleDetails: () => {},
  chooseBid: () => {},
  isSelecting: false, // loading state when selecting bid
});

const BidItem = ({
  children,
  toggleDetails,
  chooseBid,
  isSelecting,
}: PropsWithChildren<{
  toggleDetails: () => void;
  chooseBid: () => void;
  isSelecting: boolean;
}>) => {
  return (
    <BidItemContext.Provider
      value={{
        toggleDetails: toggleDetails,
        chooseBid: chooseBid,
        isSelecting,
      }}
    >
      {children}
    </BidItemContext.Provider>
  );
};

export default BidItem;
